export const ordersBy = {
  name: {
    attr: 'name',
    desc: false,
  },
  codesSyncStatus: {
    attr: 'codesSyncStatus',
    desc: false,
  },
};

export class Paging {
  constructor(pageSize, currentpage) {
    this.currentPage = currentpage || 1;
    this.pageSize = pageSize || 100;
  }
  get startFrom() {
    return (this.currentPage - 1) * this.pageSize;
  }
  reset() {
    this.currentPage = 1;
  }
}

export const OperatorsOrdersBy = {
  name: {
    attr: 'name',
    desc: false,
  },
};
export class Assetsfilter {
  constructor() {
    this.queries = ['*'];
    this.orderBy = ordersBy.name;
    this.securityGroups = [];
    this.facet = {};
    this.attrs = {};
    this.clientSideOrderBy = ordersBy.codesSyncStatus;
  }
}

export class Operatorsfilter {
  constructor() {
    this.query = '';
    this.orderBy = OperatorsOrdersBy.name;
  }
}
